<template>
  <section class="employee-ask-question-section half-cut-bg">
      <ViewQuestion></ViewQuestion>
  </section>
</template>

<script>
/* eslint-disable */
import ViewQuestion from '../common/customer-support/ViewQuestion.vue'
export default {
  name: 'AskQuestion',
  components: { ViewQuestion },
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

</style>



// WEBPACK FOOTER //
// src/components/employer/ViewQuestion.vue